<template>
  <div
    id="activity-group"
    :class="isH5 ? 'mobile-group-info' : 'pc-group-info'"
  >
    <!-- 信息 -->
    <div class="info-wrap">
      <div class="left">
        <p class="price"><span>￥</span>{{ groupSetInfo.price / 100 }}</p>
        <p class="group-num">{{ groupSetInfo.group_num }}人起拼</p>
        <img
          class="separate"
          src="../../../assets/images/product-details/group-info-separate.png"
          alt=""
        />
      </div>
      <GroupCountDown
        key="card"
        class="group-info-countdown"
        :endTime="groupSetInfo.endTime"
        :type="2"
        :callback="callback"
      />
    </div>
    <!-- 活动规则 -->
    <div @click="goActivityRule" class="rule-wrap">
      <span>活动规则</span>
      <img
        class="arrow-icon"
        src="../../../assets/images/product-details/text-btn-arrow.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
import { GroupCountDown } from "@saas/components/src";
export default {
  props: {
    groupSetInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
    };
  },
  components: {
    GroupCountDown,
  },
  methods: {
    callback() {
      // 刷新页面
      window.location.reload();
    },
    goActivityRule() {
      this.$router.push("/group-rule");
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-group-info {
  .info-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 354px;
    height: 56px;
    background: url("../../../assets/images/product-details/group-info-bg.png");
    background-size: auto 51px;
    background-position: center center;
    background-repeat: no-repeat;
    margin-bottom: 4px;
    .left {
      position: relative;
      padding-left: 10px;
      height: 100%;
      display: flex;
      flex: 1;
      align-items: center;
      .price {
        margin-right: 6px;
        color: #ffffff;
        font-weight: 600;
        span {
          font-size: 12px;
          line-height: 17px;
        }
        font-size: 24px;
        line-height: 33px;
      }
      .group-num {
        display: flex;
        align-items: center;
        height: 24px;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        line-height: 16px;
        border-radius: 8px;
        padding: 0 6px;
        border: 1px solid rgba($color: #ffffff, $alpha: 0.3);
      }
    }
    .separate {
      position: absolute;
      top: 0;
      right: -40px;
      width: 44px;
      height: 56px;
    }
  }
  .group-info-countdown {
    padding-left: 45px;
    padding-right: 10px;
    min-width: 140px;
    height: 100%;
    background: url("../../../assets/images/product-details/group-info-bg2.png");
    background-size: 100% 53px;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .rule-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    span {
      font-size: 12px;
      color: #747573;
      line-height: 17px;
    }
    img {
      width: 16px;
      height: 16px;
    }
  }
}
.mobile-group-info {
  margin-bottom: 0.23rem;
  .info-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 9.36rem;
    height: 1.48rem;
    background: url("../../../assets/images/product-details/group-info-bg.png");
    background-size: auto 1.32rem;
    background-position: center center;
    background-repeat: no-repeat;
    .left {
      position: relative;
      padding-left: 0.27rem;
      height: 100%;
      display: flex;
      flex: 1;
      align-items: center;
      .price {
        margin-right: 0.23rem;
        color: #ffffff;
        font-weight: 600;
        span {
          font-size: 0.32rem;
          line-height: 0.44rem;
        }
        font-size: 0.61rem;
        line-height: 1.48rem;
      }
      .group-num {
        display: flex;
        align-items: center;
        height: 0.63rem;
        font-weight: 500;
        font-size: 0.32rem;
        color: #ffffff;
        line-height: 0.42rem;
        border-radius: 0.21rem;
        padding: 0 0.16rem;
        border: 0.03rem solid rgba($color: #ffffff, $alpha: 0.3);
      }
    }
    .separate {
      position: absolute;
      top: 0;
      right: -40px;
      width: 1.14rem;
      height: 1.48rem;
    }
  }
  .group-info-countdown {
    padding-left: 1.14rem;
    padding-right: 0.4rem;
    min-width: 3.73rem;
    height: 100%;
    background: url("../../../assets/images/product-details/group-info-bg2.png");
    background-size: 100% 1.35rem;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .rule-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 0.15rem;
    margin-top: 0.15rem;
    span {
      font-size: 0.29rem;
      color: #747573;
    }
    img {
      width: 0.24rem;
      height: 0.24rem;
    }
  }
}
</style>
